import _ from 'lodash';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class CustomReminderService {

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
  ) { }

  getAllTemplates(templateType = 0) {
    const token = this.cookieService.get('accessToken');
    const p = {
      type: templateType,
    }

    const queryParams = [
      `access_token=${token}`,
      `p=${JSON.stringify(p)}`
    ];
    return this.http.post('/api/email/template/getAll', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  createTemplates(options) {
    const token = this.cookieService.get('accessToken');

    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify({
        "name":  options.name,
        "subject": options.subject,
        "body": options.body,
        "type": options.type,
      }))}`
    ];
    return this.http.post('/api/email/template/create', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  updateTemplates( options) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify({
        "id":options.id,
        "name":  options.name,
        "subject": options.subject,
        "body": options.body,
      }))}`
    ];
    return this.http.post('/api/email/template/update', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  deactivateTemplates(id, activate = false){
    const token = this.cookieService.get('accessToken');
    let params = {
      "id":id,
    }
    if(activate){
      params['activate'] = true;
    }
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(params))}`
    ];
    return this.http.post('/api/email/template/delete', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }
}
